import { enableProdMode, provideZoneChangeDetection } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { environment } from '@lla-platform/core/core-util'
import { AppModule } from './app/app.module'
import { install } from 'ga-gtag'

if (environment.production) {
  enableProdMode()
}

const setGooglePlacesScript = () => {
  if (!environment.googlePlacesKey) {
    return
  }
  const script = document.createElement('script')
  script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googlePlacesKey}&libraries=places,geometry,drawing&language=en`
  const head = document.getElementsByTagName('head')[0]
  head.appendChild(script)
}

setGooglePlacesScript()

install(environment.googleAnalyticsToken, { send_page_view: false })

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch((err) => console.error(err))
